import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AnswerExplanationModal } from '../modals/AnswerExplanationModal';
import { PointsNote, RevealBand } from '@quizzach/play-styles';
import { renderPoints } from '@quizzach/utils';

import { Explanation } from './Explanation';

/* Handwritten Caveat points note: »1 bod«, »0,5 boda«, »7 bodova« — with the
   scoring explanation whispering beside it. */
export const PointsRow = ({
	points,
	explanation,
}: {
	points?: string | number;
	explanation?: string;
}) => {
	const value = renderPoints(points);
	if (!value && !explanation) return null;
	return (
		<PointsNote>
			{value && <span className='val'>{value}</span>}
			{explanation && <span className='expl'>{explanation}</span>}
		</PointsNote>
	);
};

/* Full-bleed glass band revealing the answer; the explanation renders as a
   margin note (inline when short, »klikni za više« modal trigger when long). */
export const AnswerReveal = ({
	answerHtml,
	explanation,
	revealKey,
}: {
	answerHtml: string;
	explanation?: string;
	revealKey?: string | number;
}) => {
	const { t } = useTranslation();
	const [showExplanation, setShowExplanation] = useState(false);

	return (
		<>
			{showExplanation && (
				<AnswerExplanationModal
					show={showExplanation}
					closeModal={() => setShowExplanation(false)}
					explanation={explanation || ''}
				/>
			)}
			<RevealBand key={revealKey} className='fade-in-medium'>
				<span className='reveal-label'>{t('common.answer')}</span>
				<span
					className='reveal-answer'
					dangerouslySetInnerHTML={{ __html: answerHtml }}
				/>
				{explanation ? (
					<span className='reveal-why'>
						<Explanation
							explanation={explanation}
							onShowExplanation={() => setShowExplanation(true)}
						/>
					</span>
				) : null}
			</RevealBand>
		</>
	);
};
